export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  query?: Record<string, string>
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'user-management',
      displayName: 'menu.userManagement',
      meta: {
        icon: 'group',
      },
      disabled: false,
      children: [
        {
          name: 'user-list',
          displayName: 'menu.userList',
        },
        {
          name: 'user-roles',
          displayName: 'menu.userRoles',
        },
      ],
    },
    {
      name: 'product-management',
      displayName: 'menu.productManagement',
      meta: {
        icon: 'inventory_2',
      },
      children: [
        {
          name: 'product-list',
          displayName: 'menu.productList',
        },
        {
          name: 'product-categories',
          displayName: 'menu.productCategories',
        },
        {
          name: 'product-brands',
          displayName: 'menu.productBrands',
        },
      ],
    },
    {
      name: 'order-management',
      displayName: 'menu.orderManagement',
      meta: {
        icon: 'shopping_cart',
      },
      children: [
        {
          name: 'order-list',
          displayName: 'menu.orderList',
        },
        {
          name: 'order-returns',
          displayName: 'menu.orderReturns',
        },
      ],
    },
    {
      name: 'job-management',
      displayName: 'menu.jobManagement',
      meta: {
        icon: 'work',
      },
      children: [
        {
          name: 'job-list',
          displayName: 'menu.jobList',
        },
        {
          name: 'job-seeker-list',
          displayName: 'menu.jobSeekerList',
        },
      ],
    },
    {
      name: 'content-management',
      displayName: '内容管理',
      meta: {
        icon: 'article',
      },
      children: [
        {
          name: 'article-list',
          displayName: 'menu.articleList',
        },
        {
          name: 'content-migration',
          displayName: '内容迁移',
        },
      ],
    },
    {
      name: 'driving-management',
      displayName: '代驾管理',
      meta: {
        icon: 'local_taxi',
      },
      children: [
        {
          name: 'driving-order-list',
          displayName: '代驾订单',
        },
        {
          name: 'driver-list',
          displayName: '司机管理',
        },
        {
          name: 'driver-withdrawals',
          displayName: '提现管理',
        },
        {
          name: 'driving-settings',
          displayName: '代驾配置',
        },
      ],
    },
    {
      name: 'car-service-management',
      displayName: '商家管理',
      meta: {
        icon: 'store',
      },
      children: [
        {
          name: 'company-list',
          displayName: '商家列表',
        },
        {
          name: 'merchant-categories',
          displayName: '商家分类',
        },
        {
          name: 'merchant-transactions',
          displayName: '商家流水',
        },
        {
          name: 'car-wash-cards',
          displayName: '服务内容',
        },
        {
          name: 'user-car-wash-cards',
          displayName: '用户会员卡',
        },
      ],
    },
    {
      name: 'dining-management',
      displayName: '餐饮管理',
      meta: {
        icon: 'restaurant',
      },
      children: [
        {
          name: 'dining-scan-order',
          displayName: '分类管理',
        },
        {
          name: 'dining-dishes',
          displayName: '菜品管理',
        },
        {
          name: 'dining-group-buying',
          displayName: '团购管理',
        },
        {
          name: 'dining-takeout',
          displayName: '外卖管理',
        },
        {
          name: 'dining-orders',
          displayName: '订单管理',
        },
        {
          name: 'dining-tables',
          displayName: '桌台管理',
        },
        {
          name: 'dining-queue',
          displayName: '排队管理',
        },
        {
          name: 'spec-groups',
          displayName: '规格组管理',
        },
        {
          name: 'spec-options',
          displayName: '规格选项管理',
        },
        {
          name: 'coupons',
          displayName: '优惠券管理',
        },
      ],
    },
    {
      name: 'member-management',
      displayName: '会员系统',
      meta: {
        icon: 'loyalty',
      },
      children: [
        {
          name: 'member-levels',
          displayName: '会员等级',
        },
        {
          name: 'user-memberships',
          displayName: '用户会员',
        },
        {
          name: 'points-log',
          displayName: '积分记录',
        },
        {
          name: 'balance-log',
          displayName: '余额记录',
        },
        {
          name: 'recharge-orders',
          displayName: '充值订单',
        },
        {
          name: 'member-settings',
          displayName: '会员设置',
        },
      ],
    },
    {
      name: 'house-management',
      displayName: '房屋管理',
      meta: {
        icon: 'home',
      },
      children: [
        {
          name: 'house-list',
          displayName: '房屋列表',
        },
        {
          name: 'communities',
          displayName: '小区管理',
        },
        {
          name: 'house-categories',
          displayName: '房屋分类',
        },
      ],
    },
    {
      name: 'second-hand-goods-management',
      displayName: 'menu.secondHandGoods',
      meta: {
        icon: 'store',
      },
      children: [
        {
          name: 'second-hands',
          displayName: 'menu.goodsManagement',
        },
        {
          name: 'second-hand-goods-categories',
          displayName: '二手商品分类',
        },
      ],
    },
    {
      name: 'second-hand-cars-management',
      displayName: 'menu.secondHandCars',
      meta: {
        icon: 'directions_car',
      },
      children: [
        {
          name: 'second-hand-cars',
          displayName: 'menu.carsManagement',
        },
        {
          name: 'second-hand-cars-categories',
          displayName: '二手车分类',
        },
      ],
    },
    {
      name: 'life-service-management',
      displayName: '生活服务管理',
      meta: {
        icon: 'home_repair_service',
      },
      children: [
        {
          name: 'life-services',
          displayName: '服务列表',
        },
        {
          name: 'life-service-categories',
          displayName: '生活服务分类',
        },
      ],
    },
    {
      name: 'lost-found-management',
      displayName: '寻人寻物管理',
      meta: {
        icon: 'manage_search',
      },
      children: [
        {
          name: 'lost-found',
          displayName: '寻人寻物列表',
        },
        {
          name: 'lost-found-categories',
          displayName: '寻人寻物分类',
        },
      ],
    },
    {
      name: 'free-zone-management',
      displayName: '0元专区管理',
      meta: {
        icon: 'card_giftcard',
      },
      children: [
        {
          name: 'free-zone',
          displayName: '0元专区列表',
        },
        {
          name: 'free-zone-categories',
          displayName: '0元专区分类',
        },
      ],
    },
    {
      name: 'system-settings',
      displayName: 'menu.systemSettings',
      meta: {
        icon: 'settings',
      },
      children: [
        {
          name: 'site-settings',
          displayName: '站点设置',
          query: { tab: 'site' },
        },
        {
          name: 'site-settings',
          displayName: '附件设置',
          query: { tab: 'attachments' },
        },
        {
          name: 'site-settings',
          displayName: '三方接口/密钥配置',
          query: { tab: 'thirdparty' },
        },
        {
          name: 'site-settings',
          displayName: '支付设置',
          query: { tab: 'payment' },
        },
        {
          name: 'site-settings',
          displayName: 'APP 导航',
          query: { tab: 'app_category' },
        },
        {
          name: 'site-settings',
          displayName: '广告管理',
          query: { tab: 'advertisement' },
        },
      ],
    },
  ] as INavigationRoute[],
}
